import React, { memo, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';

import { UeElement, UeType } from '@oneaudi/falcon-tools';
import { convertRichText } from '../utils/richtextUtils';
import { useTracking } from '../hooks/useTracking';

export const StyledText = styled.span<{ className?: string }>`
  & p,
  br {
    margin: 0;
    padding: 0;
    margin-bottom: var(--spacing-relative-md);
  }
  a {
    color: inherit;
  }
`;

export interface TextProps {
  readonly text: string;
  readonly property: string;
  readonly type: UeType;
  readonly label: string;
  readonly className?: string;
}

export default memo(function RichText(props: TextProps) {
  const textRef = useRef<HTMLSpanElement | null>(null);
  const trackingManager = useTracking();

  useEffect(() => {
    const setTrackingToLinkElement = () => {
      if (!textRef) return;
      if (!textRef.current) return;
      if (!textRef.current?.querySelectorAll('a')) return;
      if (typeof window === 'undefined') return;

      const textLinks = textRef.current.querySelectorAll('a');

      textLinks.forEach((el) => {
        const src = el.getAttributeNode('href')?.value as string;
        const label = el.innerText || '';

        const regexStartWithHash = /^#.*$/;

        if (src && !regexStartWithHash.test(src)) {
          // eslint-disable-next-line no-restricted-globals
          el.addEventListener('click', () => {
            // set opening tag by cliking as a default because all link in the richtext can not set it
            el.setAttribute('target', '_blank');

            trackingManager.sendClickEvent(label, src, 'text link', 'text link');
          });
        }
      });
    };

    return setTrackingToLinkElement();
  }, [trackingManager]);

  return (
    <Text tag="span" variant={{ type: 'copy', order: '1', style: 'normal' }}>
      <StyledText ref={textRef} className={props.className}>
        <UeElement type={props.type} property={props.property} label={props.label}>
          {convertRichText(props.text)}
        </UeElement>
      </StyledText>
    </Text>
  );
});
